import {
  AccountCircleRounded
} from "@mui/icons-material"
import { IconButton } from "@mui/material"
import { useNavigate } from "react-router-dom"
import Navigation from "../components/navigation"

export default function Dashboard() {
  const navigate = useNavigate()
  const title = 'Dashboard'

  return (
    <Navigation
      title={title}
      actions={
        <>
          <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="account-appbar"
            aria-haspopup="true"
            color="inherit"
            edge="end"
            onClick={() => navigate('/account')}
          >
            <AccountCircleRounded />
          </IconButton>
        </>
      }
    >
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center"
        }}
      >
        <div>
          <p
            style={{
              marginTop: "2",
              justifyContent: "center",
              paddingInline: "1em",
              fontSize: "3em",
              fontWeight: "bold"
            }}
          >
            Welcome to the Index Braille Distributor website.
          </p>
          <p
            style={{
              fontSize: "1.7em"
            }}
          >
            Waiting for an admin to manage your privileges...
          </p>
        </div>
      </div>
    </Navigation>
  )
}